import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import dayjs from 'dayjs';
import { Employment } from 'src/app/shared/models/employment.model';
import { ROUTE_EMPLOYED_FORM, ROUTE_EMPLOYMENT_HISTORY, ROUTE_UNEMPLOYED_FORM } from 'src/app/shared/routes';
import { StorageService } from 'src/app/shared/storage/storage.service';

const DELETE_MESSAGE = 'Are you sure you want to delete the employment?';

@Component({
  selector: 'app-employment-view',
  templateUrl: './employment-view.component.html',
  styleUrls: ['./employment-view.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule
  ]
})
export class EmploymentViewComponent implements OnInit {
  @Input() model: Employment;
  @Input() index: number;
  @Input() isOnlyCurrentEmployment: any;
  currentDate = new Date();
  @Output() updateEmploymentPressed: EventEmitter<Employment> = new EventEmitter<Employment>();
  @Output() deleteEmploymentPressed: EventEmitter<Employment> = new EventEmitter<Employment>();
  @Output() openEmploymentFormPressed = new EventEmitter<number>();
  @Output() openUnEmploymentFormPressed = new EventEmitter<number>();
  isGapItem: boolean = false;
  gapDateRange: string = '';

  @Input() prevModel: Employment;
  @Input() nextModel: Employment;
  /** True when this row is missing details required by the employed form (e.g. carrier auto-hire). */
  @Input() needsMandatoryFieldsCompletion = false;

  constructor(private readonly storageService: StorageService, private readonly router: Router) { }

  ngOnInit(): void {
    if (this.model.fromDate) {
      this.model = {
        ...this.model,
        fromDate: dayjs(this.model.fromDate).format('YYYY-MM-DD')
      };
    }
    if (this.model.fromDate == null) {
      this.isGapItem = true;
      this.buildGapDateRange();
    }
    if (this.model.toDate) {
      let toDate =
        this.model && this.model.toDate
          ? dayjs(this.model.toDate).format('YYYY-MM-DD')
          : dayjs(this.currentDate).format('YYYY-MM-DD');

      this.model = {
        ...this.model,
        toDate: toDate
      };
    }
  }

  private buildGapDateRange(): void {
    const from = this.nextModel?.toDate ? dayjs(this.nextModel.toDate).format('MMM YYYY') : null;
    const to = this.prevModel?.fromDate ? dayjs(this.prevModel.fromDate).format('MMM YYYY') : null;
    if (from && to) {
      this.gapDateRange = `${from} – ${to}`;
    }
  }

  onUpdateEmp(): void {
    this.updateEmploymentPressed.emit(this.model);
  }

  onDeleteEmp(): void {
    if (confirm(DELETE_MESSAGE)) {
      this.deleteEmploymentPressed.emit(this.model);
    }
  }
  openEmploymentForm(): void {
    this.openEmploymentFormPressed.emit(this.index);
  }
  openUnEmploymentForm(): void {
    this.openUnEmploymentFormPressed.emit(this.index);
  }
  checkDeletePermission(): boolean {
    // Only allow delete for non-current employment
    // Never show delete icon for current employment
    return !this.model.isCurrentEmployment;
  }
  onAddNewCurrentEmployment(isEmploymentForm: boolean, model?: Employment): void {
    this.storageService.store('currentEmploymentState', model);
    let path = '';
    if (isEmploymentForm) {
      path = `/${ROUTE_EMPLOYMENT_HISTORY}/${ROUTE_EMPLOYED_FORM}?newCurrentAddress=true`;
    } else {
      path = `/${ROUTE_EMPLOYMENT_HISTORY}/${ROUTE_UNEMPLOYED_FORM}?newCurrentAddress=true`;
    }
    this.router.navigateByUrl(path);
  }
}
